import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as AuthActions from '../../../store/auth/auth.actions';
import { selectIsLoading } from '../../../store/auth/auth.selectors';

import { CustomInputComponent } from '../../../shared/components/custom-input/custom-input.component';
import { CustomPasswordInputComponent } from '../../../shared/components/custom-password-input/custom-password-input.component';
import { CustomButtonComponent } from '../../../shared/components/custom-button/custom-button.component';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CustomInputComponent, CustomPasswordInputComponent, NgOptimizedImage],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  loginForm: FormGroup;
  isLoading$: Observable<boolean>;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private store: Store
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.isLoading$ = this.store.select(selectIsLoading);
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.store.dispatch(AuthActions.login({ request: this.loginForm.value }));
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
